import { render, staticRenderFns } from "./tabs-personal-info.vue?vue&type=template&id=31072dbc&"
import script from "./tabs-personal-info.vue?vue&type=script&lang=js&"
export * from "./tabs-personal-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports